import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { ReservationsVehicleStayList } from 'src/features/reservations/types/reservationType';

interface DTO {
    parkingId: string;
    reservationId: string;
}

const RESOURCE = 'reservations/:parkingId/vehicle-stay-reservation/:reservationId/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, reservationId, ...data }: DTO): Promise<ReservationsVehicleStayList> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, reservationId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateReservationVehicleStay };
